import { boolean, object, string } from 'yup';
import {
  IAddressNullable,
  IAddressNullableInput,
  IAddressNullableSchema,
} from '../address/IAddressNullable';

export const IInsuranceSchema = object({
  id: string(),
  name: string(),
  address: IAddressNullableSchema.optional().default(undefined),
  phoneNumber: string().notRequired().nullable(),
  faxNumber: string().notRequired().nullable(),
  email: string().notRequired().nullable(),
  dispatchEmail: string().notRequired().nullable(),
});

export type IInsurance = {
  id: string;
  name: string;
  address?: IAddressNullable | null;
  phoneNumber?: string;
  faxNumber?: string;
  email?: string;
  dispatchEmail?: string;
  splitInvoice: boolean;
  disableSurcharge132gp3: boolean;
  costObjectNumber: string;
  customCostObjectNumber?: string;
};

export const IInsuranceCreateSchema = object({
  name: string().trim().required(),
  address: IAddressNullableSchema,
  phoneNumber: string().trim().optional(),
  faxNumber: string().trim().optional(),
  email: string().trim().optional(),
  dispatchEmail: string().trim().optional().nullable(),
  splitInvoice: boolean().required(),
  disableSurcharge132gp3: boolean().required(),
  customCostObjectNumber: string().trim().optional().nullable().default(undefined),
});

export type IInsuranceCreate = {
  name: string;
  address?: IAddressNullableInput;
  phoneNumber?: string;
  faxNumber?: string;
  email?: string;
  dispatchEmail?: string;
  splitInvoice: boolean;
  disableSurcharge132gp3: boolean;
};

export const IInsuranceUpdateSchema = object({
  name: string().trim().optional(),
  address: IAddressNullableSchema,
  phoneNumber: string().trim().optional(),
  faxNumber: string().trim().optional(),
  email: string().trim().optional(),
  dispatchEmail: string().trim().optional().nullable(),
  splitInvoice: boolean().required(),
  disableSurcharge132gp3: boolean().required(),
  customCostObjectNumber: string().trim().optional().nullable().default(undefined),
});

export type IInsuranceUpdate = {
  name?: string;
  address?: IAddressNullableInput;
  phoneNumber?: string;
  faxNumber?: string;
  email?: string;
  dispatchEmail?: string;
  splitInvoice?: boolean;
  disableSurcharge132gp3?: boolean;
  customCostObjectNumber?: string;
};
